module.exports = __webpack_public_path__ + "531007dc435066ede741ef61659e20f7.pdf";